const ApiAttributesKeys = {
  chapterIdKey: 'chapterId',
  readingIdKey: 'reading_id',
  chapterNameKay: 'chapterName',
  totalReadingKey: 'totalReading',
  freeQuestionsCountKey: 'totalFreeQuestions',
  premiumQuestionsCountKey: 'totalQuestions',
  tableKey: 'cfa1_2025_note',
  tableChapterKey: 'chapter_id',
  //* notes key's
  totalNotesKey: 'totalNotes',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/ApiAttributesKays.js